export const CHECK_MATCH_LOOP = 60000;
export const LOOP = 1000;
